export const ConsentInfoActionType = {
    SET_CONSENT_FORM_FIELDS: "SET_CONSENT_FORM_FIELDS",
    UPDATE_CONSENT_FORM_VALUES: "UPDATE_CONSENT_FORM_VALUES",
    SET_CONSENT_TYPE: "SET_CONSENT_TYPE",
    SET_CONSENT_ID: "SET_CONSENT_ID",
    SET_CONSENT_ERROR_SCREEN_MESSAGE: "SET_CONSENT_ERROR_SCREEN_MESSAGE"
}